// Production PBX backend, reached directly over its own trusted subdomain
// (real Let's Encrypt cert) — no proxy layer needed, unlike the old
// Netlify Functions bridge this replaced.
export const PBX_API_ORIGIN = process.env.REACT_APP_PBX_API_ORIGIN || "https://api.ownpbx.in";
